import { GetGuestResponse } from '@carlito/hub-react';

export function determineWillBePutOnWaitingList(
  numNewParticipants: number,
  maxParticipants?: number
): boolean {
  const willBePutOnWaitingList = maxParticipants ? numNewParticipants > maxParticipants : false;

  return willBePutOnWaitingList;
}

type MakeRequired<T> = {
  [K in keyof T]-?: T[K];
};

type CurrentReservation = MakeRequired<GetGuestResponse>['loggedInGuest']['currentReservation'];
export function eventParticipantDto(currentReservation?: CurrentReservation, guestId?: string) {
  const guests = currentReservation?.guests?.sort((a, b) => {
    if (a.data.id === guestId) {
      return -1;
    }
    if (b.data.id === guestId) {
      return 1;
    }
    return 0;
  });
  return (guests ?? []).map((guest) => ({
    roomNr: currentReservation?.room?.roomNumber,
    id: guest.data.id,
    isMainBooker: guest.data.id === guestId,
    displayName: `${guest.data.firstName} ${guest.data.lastName}`,
  }));
}
